const baseURL = "/v1/PosLogin";

const service = {
  methods: {
    $cadastrarCadastroPedagogicoPosLogin(body) {
      return this.$api().post(`${baseURL}/SolicitarAcesso`, body);
    },
  },
};

export default service;
